import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { ButtonComponent } from '@sirius/common';

@Component({
    selector: 'matchmaking-form-submit-button',
    imports: [ButtonComponent],
    templateUrl: './form-submit-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-submit-button.component.scss'
})
export class FormSubmitButtonComponent {
    @Input()
    isDisabled!: boolean;

    @Input()
    text!: string;

    @Output()
    triggerSubmitEvent = new EventEmitter<void>();

    public submitEvent() {
        if (!this.isDisabled) {
            this.triggerSubmitEvent.emit();
        }
    }
}
